/**
 * OCPP 2.1 adapter.
 *
 * OCPP 2.1 is a backward-compatible superset of 2.0.1 at the OCPP-J framework
 * level: the shared message set (boot / authorize / transaction / device model
 * / smart charging / reservations / firmware / certificates / monitoring …) is
 * unchanged in shape, so this reuses the entire OcppV201Adapter and only swaps
 * in the 2.1 schema registry (validation against the real 2.1 schemas) and the
 * `ocpp2.1` WebSocket subprotocol.
 *
 * 2.1-only message families — DER control / bidirectional V2X, tariffs &
 * pricing, battery swap, periodic event streams, ISO 15118-20 — are layered on
 * top in follow-ups (they need OcppV201Adapter.#send promoted to a shared/
 * protected send, tracked separately). `instanceof OcppV201Adapter` stays true,
 * so every v2.0.1 CSMS-call handler applies to a 2.1 station for the shared set.
 */
import {
  OcppV201Adapter,
  type OcppCallSinkV201,
  type OcppV201AdapterOptions,
} from '@/protocol/v201/OcppV201Adapter';
import { validatorFor as validatorForV21 } from './schemas';

export const V21_VERSION_LABEL = '2.1';

export class OcppV21Adapter extends OcppV201Adapter {
  constructor(opts: OcppV201AdapterOptions | OcppCallSinkV201) {
    const base: OcppV201AdapterOptions = 'call' in opts ? { sink: opts } : opts;
    super({ ...base, subprotocol: 'ocpp2.1', schemaValidator: validatorForV21 });
  }
}
